"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicDiscount = exports.getPublicDiscounts = exports.deleteDiscountRelation = exports.postDiscountRelation = exports.putDiscountOrganization = exports.putDiscountAccessibility = exports.deleteDiscountPermission = exports.postDiscountPermission = exports.putDiscountAction = exports.postDiscount = exports.putDiscount = exports.getDiscount = exports.getDiscounts = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var discountsAuthorizedPath = root_1.ecommerceAuthorized + '/discounts/';
var discountsPublicPath = root_1.ecommercePublic + '/discounts/';

var getDiscounts = function getDiscounts(authentication, queryParameters) {
  return common_1.get(authentication, discountsAuthorizedPath, queryParameters);
};

exports.getDiscounts = getDiscounts;

var getDiscount = function getDiscount(authentication, id) {
  return common_1.get(authentication, discountsAuthorizedPath + id);
};

exports.getDiscount = getDiscount;

var putDiscount = function putDiscount(authentication, discount) {
  return common_1.put(authentication, discountsAuthorizedPath + discount.id, discount);
};

exports.putDiscount = putDiscount;

var postDiscount = function postDiscount(authentication, discount) {
  return common_1.post(authentication, discountsAuthorizedPath, discount);
};

exports.postDiscount = postDiscount;

var putDiscountAction = function putDiscountAction(authentication, id, action, data) {
  return common_1.putSub(authentication, discountsAuthorizedPath, id, action, data);
};

exports.putDiscountAction = putDiscountAction;

var postDiscountPermission = function postDiscountPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, discountsAuthorizedPath, id, permission);
};

exports.postDiscountPermission = postDiscountPermission;

var deleteDiscountPermission = function deleteDiscountPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, discountsAuthorizedPath, id, permissionId);
};

exports.deleteDiscountPermission = deleteDiscountPermission;

var putDiscountAccessibility = function putDiscountAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, discountsAuthorizedPath, id, accessibility);
};

exports.putDiscountAccessibility = putDiscountAccessibility;

var putDiscountOrganization = function putDiscountOrganization(authentication, id, accessibility) {
  return common_1.putEntityOrganization(authentication, discountsAuthorizedPath, id, accessibility);
};

exports.putDiscountOrganization = putDiscountOrganization;

var postDiscountRelation = function postDiscountRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, discountsAuthorizedPath, id, relation);
};

exports.postDiscountRelation = postDiscountRelation;

var deleteDiscountRelation = function deleteDiscountRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, discountsAuthorizedPath, id, relationId);
};

exports.deleteDiscountRelation = deleteDiscountRelation;

var getPublicDiscounts = function getPublicDiscounts(authentication, queryParameters) {
  return common_1.get(authentication, discountsPublicPath, queryParameters);
};

exports.getPublicDiscounts = getPublicDiscounts;

var getPublicDiscount = function getPublicDiscount(authentication, id) {
  return common_1.get(authentication, discountsPublicPath + id);
};

exports.getPublicDiscount = getPublicDiscount;